import {
    Component,
    ViewEncapsulation,
    ViewChild,
    Input,
    OnChanges,
    SimpleChanges,
    OnDestroy,
    Output, EventEmitter, OnInit
} from '@angular/core';
import {Ajax, L10n, loadCldr} from '@syncfusion/ej2-base';
import {TimeScaleModel, GroupModel, EventSettingsModel, RenderCellEventArgs} from '@syncfusion/ej2-angular-schedule';
import {
    ScheduleComponent,
    PopupOpenEventArgs,
    EventClickArgs,
    NavigatingEventArgs
} from '@syncfusion/ej2-angular-schedule';
import {Subscription} from 'rxjs/Subscription';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {AppUtils, StringUtils} from '../../../shared/utils';
import {DataManager, Query, UrlAdaptor, WebApiAdaptor} from '@syncfusion/ej2-data';
import {environment} from '../../../../environments/environment';
import {AppServices} from '../../../shared/services';
import {CommonServices} from '../../../shared/services/src/api';
import {ScheduleServices} from '../../../shared/services/src/api/schedule.services';
import {Router} from '@angular/router';
import {EnvUtils} from '../../../shared/utils';

/*import {SelectItem} from '../..';*/
import {ValidatorUtils} from '../../../shared/utils/src/validator.utils';
import {StorageUtils} from '../../../shared/utils/src/storage.utils';
import {ColorPicker} from '../../../shared/enums/color-picker.enum';
import {AuthServices} from '../../../shared/authentications';
import {OvrdApplyScopeEnum} from '../../../shared/enums/ovrd-apply-scope.enum';
import * as _ from 'lodash';

L10n.load({
    'en': {
        schedule: {
            'today': 'Today'
        },
        calendar: {
            'today': 'Today'
        }
    },
    'ko': {
        schedule: {
            'today': '오늘'
        },
        calendar: {
            'today': '오늘'
        }
    },
    'zh': {
        schedule: {
            'today': '今天'
        },
        calendar: {
            'today': '今天'
        }
    },
    'ja': {
        schedule: {
            'today': '今日'
        },
        calendar: {
            'today': '今日'
        }
    }
});

loadCldr(
    require('../cldr-data/numberingSystems.json'),
    require('../cldr-data/ko/ca-gregorian.json'),
    require('../cldr-data/ko/numbers.json'),
    require('../cldr-data/ko/timeZoneNames.json'),
    require('../cldr-data/en-150/ca-gregorian.json'),
    require('../cldr-data/en-150/numbers.json'),
    require('../cldr-data/en-150/timeZoneNames.json'),
    require('../cldr-data/zh/ca-gregorian.json'),
    require('../cldr-data/zh/numbers.json'),
    require('../cldr-data/zh/timeZoneNames.json'),
    require('../cldr-data/ja/ca-gregorian.json'),
    require('../cldr-data/ja/numbers.json'),
    require('../cldr-data/ja/timeZoneNames.json')
);

@Component({
    selector: 'syncfusion-scheduler-timeline-view',
    templateUrl: 'timeline-view.component.html',
    styleUrls: ['../syncfusion.custom.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TimelineViewComponent implements OnInit, OnChanges, OnDestroy {
    access_token = EnvUtils.envCdToAccessToken();
    @ViewChild('overrideCreatePopup') overrideCreatePopup;
    @ViewChild('scheduleObj') public scheduleObj: ScheduleComponent;
    @Input() public showHeaderBar = true;
    @Input() public schdNo = 0;
    @Input() public type = 'chart';                         //chart or preview
    @Input() public viewType = 'timeline';                  //timeline or calendar
    @Input() public previewConfig = {};
    @Input() public tmznOfsVal;
    @Input() public layerCnt: number;
    @Input() public usedUserList = [];
    @Input() public customPopupUseYn = true;
    @Input() public schd;

    overrideDataLoading = true ;       //오버라이드 팝업의 스피너를 위한 파라미터

    public timeScale: TimeScaleModel = {enable: true, interval: 1440, slotCount: 1};               //스케쥴러에 시간 개념적용
    public selectedDate: Date = new Date();
    public currentDate: Date = new Date();
    public oneDayAgoDate: Date = new Date();
    public group: GroupModel = {
        byGroupID: false,
        resources: ['Layers']
    };
    public categoryDataSource = [];

    private dataManager: DataManager;
    /* = new DataManager({
        url: this.url, //'http://alertnowlocal.opsnow.com:8080/api/v1/1/schedule/10001?chartViewStDt=2019-02-08&chartViewOfsVal=2w'
        headers : [{'Authorization' : 'Bearer 9255243b-a7df-465f-9e4f-c707092ae14a'},
            {'Content-Type': 'application/json'}
        ] ,
        adaptor: new CustomAdaptor,
        crossDomain: true
    });*/

    private dataQuery: Query = new Query(); //.addParams('tmznOfsVal', encodeURIComponent('+09:00'));
    public eventSettings: EventSettingsModel; //= { dataSource: this.dataManager, query: this.dataQuery };
    private subscription: Subscription;

    ovrdPopupType = 'DELETE';
    ovrdLayerNo = 0;
    ovrdStDt = '';
    ovrdEdDt = '';

    deleteTarget = {};
    viewDisplayName = {
        day: this.translate.instant('MK.01371'),
        week: this.translate.instant('MK.01372'),
        week2: this.translate.instant('MK.01373'),
        month: this.translate.instant('MK.01374'),
    };
    public locale = 'ko';
    // isChartLoading = false;
    @Output() chartLoaded: EventEmitter<any> = new EventEmitter(true);

    /******************** Override Variable start ********************/
    @Output() public reloaded: EventEmitter<any> = new EventEmitter(true);
    @Output() public dataLoaded: EventEmitter<any> = new EventEmitter(true);
    @Output() public scheduleNo: EventEmitter<any> = new EventEmitter(true);
    @Output() public previewOvrdDelete: EventEmitter<any> = new EventEmitter(true);

    schdLayerNo = 0;
    userNo = 0;
    public useritems: Array<any> = [];
    activeData = [];

    dateTime = {
        stDate: '',
        stTime: '',
        endDate: '',
        endTime: ''
    };
    tmznCd = '';

    ovrdAplyScopeCd = 'OVRDSCOPE20';

    invalidCnt = 0;
    isEmptyUser = false;
    isEndBfSt = false;
    isEndBfNow = false;
    isTrgtNoInvalid = false;

    // 타임존 셀렉트박스
    public TimezoneTypeSelectConfig: any = {
        id: 'timezoneType',
        name: 'timezoneType',
        defaultOption: {
            useFlag: false,
            label: '',
            value: ''
        },
        option: []
    };
    /******************** Override Variable end ********************/

    onlyChartTf = true; //preview 이용시 처음 한번은 chart만 이용
    showDatePicker = false;
    alertNowDebug;
    isHide = false;

    ovrdDelAll = false;
    constructor(private translate: TranslateService,
                private appServices: AppServices,
                private authService: AuthServices,
                private router: Router,
                private commonServices: CommonServices,
                private scheduleServices: ScheduleServices) {
        const pathname = location.pathname.split('/');
        if (pathname[2] === 'new' || pathname[2] === 'copy') {
            this.isHide = true;
        }

        this.tmznOfsVal = AppUtils.getUseTimezone().tmznOfs;
        this.tmznCd = AppUtils.getUseTimezone().tmznCd;

        const debugStr = StorageUtils.getItem('alertNow.debug');
        if (debugStr) {
            this.alertNowDebug = JSON.parse(debugStr);
        } else {
            this.alertNowDebug = {
                syncfusion : false
            };
        }
        //ko en zh

        if (this.translate.currentLang === 'en') {
            this.locale = 'en-150';
        } else {
            this.locale = this.translate.currentLang;
        }
        /*switch (this.translate.currentLang) {
            case 'ko':
                this.locale = 'ko';
                break;
            case 'en':
                this.locale = 'en-150';
                break;
            case 'zh':
                this.locale = 'zh';
                break;
        }*/

        this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.getTimeZone();

            if (event.lang === 'en') {
                this.locale = 'en-150';
            } else {
                this.locale = event.lang;
            }
            /*switch (event.lang) {
                case 'ko':
                    this.locale = 'ko';
                    break;
                case 'en':
                    this.locale = 'en-150';
                    break;
                case 'zh':
                    this.locale = 'zh';
                    break;
            }*/

            /*  this.dayIsSelected = this.scheduleObj.viewIndex === 0;
              this.weekIsSelected = this.scheduleObj.viewIndex === 1;
              this.week2IsSelected = this.scheduleObj.viewIndex === 2;
              this.monthIsSelected = this.scheduleObj.viewIndex === 3;
  */
            const text1 = this.translate.instant('MK.01371');
            const text2 = this.translate.instant('MK.01372');
            const text3 = this.translate.instant('MK.01373');
            const text4 = this.translate.instant('MK.01374');

            this.selectedDate = new Date();

            try {
                this.scheduleObj.setProperties({
                    views: [
                        {
                            displayName: text1,
                            option: 'TimelineDay',
                            isSelected: false,
                            interval: 1
                        },
                        {
                            displayName: text2,
                            option: 'TimelineDay',
                            isSelected: false,
                            interval: 7
                        },
                        {
                            displayName: text3,
                            option: 'TimelineDay',
                            isSelected: true,
                            interval: 14
                        },
                        {
                            displayName: text4,
                            option: 'TimelineDay',
                            isSelected: false,
                            interval: 31
                        }]
                });

            } catch (e) {
                console.log(e);
            }
        });
    }

    ngOnInit(): void {
        this.oneDayAgoDate.setDate(this.currentDate.getDate() - 1);
        if (this.schdNo !== undefined && this.type === 'chart') {
            ///layerCnt
            if (this.layerCnt) {
                for (let i = 0; i < this.layerCnt; i++) {
                    this.categoryDataSource.push({text: `Layer-${i + 1}`, id: (i + 1)});
                }
            } else {
                this.categoryDataSource.push({text: 'Layer-1', id: 0});
            }

            this.getChartData();
        } else if (this.type === 'preview') {
            //console.log('프리뷰!');
            this.categoryDataSource.push({text: 'Layer-1', id: 1});
            //console.log(this.schdNo, this.previewConfig['schdLayerNo']);
            if (this.schdNo && this.previewConfig['schdLayerNo']) {
                this.getPreviewData();
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        const chng = changes['tmznOfsVal'];
        if (this.type === 'chart' && chng !== undefined && chng.previousValue !== undefined) {
            this.getChartData();
        }

    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public getChartData(schdNo?) {
        // this.isChartLoading = true;
        this.chartLoaded.emit({flag: false, schdNo: this.schdNo});

        const apiUrl = `${environment.apiUrl}/api/v1`;
        const url = `${apiUrl}/${global['loginUser'].curCmpnId}/schedule/chart/${schdNo !== undefined ? schdNo : this.schdNo}`;
        this.dataManager = new DataManager({
            url: url,
            headers: [{'Authorization': `Bearer ${this.access_token}`},
                {'Content-Type': 'application/json'}
            ],
            adaptor: new CustomAdaptor,
            crossDomain: true
        });

        this.dataQuery = new Query().addParams('tmznOfsVal', encodeURIComponent(this.tmznOfsVal)).addParams('excludeOvrdLayerTf', 'F');

        this.eventSettings = {dataSource: this.dataManager, query: this.dataQuery};
    }

    public dataBinding(args) {
        if (this.type === 'chart') {
            // 차트 로드 완료
            this.chartLoaded.emit({flag: true, schdNo: this.schdNo});

            const layerCnt: number = Number(StorageUtils.getItem('alertnow.chartLayer.cnt'));
            if (this.layerCnt !== layerCnt) {
                this.categoryDataSource = [];

                for (let i = 0; i < layerCnt; i++) {
                    this.categoryDataSource.push({text: `Layer-${i + 1}`, id: (i + 1)});
                }

                this.layerCnt = layerCnt;
            }

            // this.isChartLoading = false;
        } else if (this.type === 'preview') {
            this.onlyChartTf = false;
        }

        //if (this.viewType === 'timeline' && !this.alertNowDebug.syncfusion) {
            // timeline view 에서만 더보기 엘리먼트 삭제
            //$('.e-more-indicator').remove();
        //}
    }

    public getPreviewData() {
        // this.isChartLoading = true;
        const postData = JSON.parse(JSON.stringify(this.previewConfig));

        if (postData.rotnTypeCd === 'SCHRTN10') {
            postData.intvUnitCd = 'TU_DAY';
            postData.intvVal = '1';
        } else if (postData.rotnTypeCd === 'SCHRTN20') {
            postData.intvUnitCd = 'TU_WEEK';
            postData.intvVal = '1';
        }
        postData.aplyStDt = `${postData.aplyStDt_temp.date} ${postData.aplyStDt_temp.time}:00`;

        postData.tmznOfsVal = this.tmznOfsVal;

        if (!postData.schdLayerOnCallCnfg.useYN) {
            postData.schdLayerOnCallCnfgList = [];
        }

        postData.schdLayerOnCallCnfgList = _.filter(postData.schdLayerOnCallCnfgList, {'onCallCnfgTypeCd' : postData.schdLayerOnCallCnfg.type});

        delete postData.aplyStDt_temp;
        //delete postData.schdLayerOnCallCnfg;
        delete postData.foldFlag;
        delete postData.validator;
        delete postData.deleteTemplate;

        //사용자 정보 local에 저장 start
        const mappTrgtInfo = [];
        postData.schdLayerMappCnfgList.forEach((mappCnfg, index) => {
            mappCnfg.index = index;

            mappTrgtInfo.push({
                type: 'layer',
                layerNo: postData.schdLayerNo ? postData.schdLayerNo : 0,
                asgnOrdrIdx: index + 1,
                trgtDispNm: mappCnfg.mappTrgtDispNm,
                trgtNo: mappCnfg.mappTrgtNo,
                colorIndex: _.find(this.usedUserList, {'trgtNo': mappCnfg.mappTrgtNo}).colorIndex,
                trgtStatCd: 'UAST10',
                trgtRoleCd: mappCnfg.mappTrgtRoleCd,
                trgtRoleNo: mappCnfg.mappTrgtRoleNo
            });
        });

        //StorageUtils.setItem('alertNow.mappTrgtInfo.preview', JSON.stringify(mappTrgtInfo));
        const mappTrgtInfoPreviewStr = StorageUtils.getItem(`alertNow.mappTrgtInfo.preview.${this.schdNo}`);
        const mappTrgtInfoPreview = mappTrgtInfoPreviewStr === null ? {} : JSON.parse(mappTrgtInfoPreviewStr);
        mappTrgtInfoPreview[postData.schdLayerNo] = mappTrgtInfo;

        StorageUtils.setItem(`alertNow.mappTrgtInfo.preview.${this.schdNo}`, JSON.stringify(mappTrgtInfoPreview));

        //override가 있는지 체크해서 존재하면 layer를 두개로 늘리자
        // console.log(postData);
        if (postData.schdOvrdLayerList) {
            const mappTrgtOvrdInfo = [];
            postData.schdOvrdLayerList.forEach(ovrd => {
                //console.log(ovrd);
                mappTrgtOvrdInfo.push({
                    type: 'override',
                    layerNo: postData.schdLayerNo ? postData.schdLayerNo : 0,
                    asgnOrdrIdx: null,
                    trgtDispNm: ovrd.mappTrgtDispNm,
                    trgtNo: ovrd.mappTrgtNo,
                    colorIndex: 1,
                    trgtStatCd: 'UAST10',
                    trgtRoleCd: ovrd.mappTrgtRoleCd,
                    trgtRoleNo: ovrd.mappTrgtRoleNo
                });
            });
            if (this.categoryDataSource.length === 1) {
                this.categoryDataSource = [{text: 'Layer-1', id: 1}, {text: 'Layer-2', id: 2}];
            }

        }
        //사용자 정보 local 저장 끝

        const apiUrl = `${environment.apiUrl}/api/v1`;
        const url = `${apiUrl}/${global['loginUser'].curCmpnId}/schedule/preview/${this.schdNo}`;
        this.dataManager = new DataManager({
            url: url,
            headers: [{'Authorization': `Bearer ${this.access_token}`}],
            adaptor: new PreviewAdaptor,
            crossDomain: true
        });

        let withChartTf = 'F';
        if (this.schdNo !== 0 && postData.schdLayerNo) {
            withChartTf = 'T';
        }

        this.dataQuery = new Query().addParams('schdLayer', postData as any).addParams('withChartTf', withChartTf).addParams('onlyChartTf', this.onlyChartTf ? 'T' : 'F');
        this.eventSettings = {dataSource: this.dataManager, query: this.dataQuery};
    }

    onEventRendered(args: any): void {
        const categoryColor: string = args.data.CategoryColor as string;
        args.element.style.backgroundColor = categoryColor;

        if (args.data.trgtStatCd !== 'UAST10') {
            args.element.classList.add('invalid');
        }

        if (args.data.trgtRoleCd === undefined || args.data.trgtRoleCd === 'ROLE_OBSVR') {
            args.element.classList.add('invalid');
        }
    }

    onRenderCell(args: RenderCellEventArgs): void {
        //타임라인 헤더의 날짜 표시 방법 변경
        if (args.elementType === 'dateHeader') {
            const weekText = [
                this.translate.instant('MK.00868'),
                this.translate.instant('MK.00869'),
                this.translate.instant('MK.00870'),
                this.translate.instant('MK.00871'),
                this.translate.instant('MK.00872'),
                this.translate.instant('MK.00873'),
                this.translate.instant('MK.00874'),
            ];
            const dayOfWeek = weekText[args.date.getDay()];
            if (this.translate.currentLang === 'en') {
                args.element.getElementsByClassName('e-header-date')[0].innerHTML = `${dayOfWeek} ${(args.date.getMonth() + 1).toString()}/${args.date.getDate().toString()}`;
            } else {
                args.element.getElementsByClassName('e-header-date')[0].innerHTML = `${(args.date.getMonth() + 1).toString()}/${args.date.getDate().toString()} ${dayOfWeek}`;
            }
        }

        //과거일자 백그라운드

        if (args.element.classList.contains('e-work-cells') && this.oneDayAgoDate > args.date) {
            //args.element['style'].background = '#deecfc';
            args.element.classList.add('past');

            /*setTimeout( () => {
              //timeline 경과한 left값을 pastoverlay width값으로 하기 위해서
              const timeLineLeft = document.querySelectorAll('.e-current-timeline');
              const $timeLineEach = Array.prototype.slice.call(timeLineLeft);

              //time라인 경과한 부분을 나타내주는 div
              const pastOverlay = document.createElement('div');

              $timeLineEach.forEach( (el) => {
                pastOverlay.classList.add('past-overlay');
                args.element.appendChild(pastOverlay);
              });
            }, 500);*/
        }

        if (args.element.classList.contains('e-header-cells') && this.currentDate > args.date) {
            args.element.classList.add('past');
        }
        /*if (args.element.classList.contains('e-work-hours') && (args.date.getDate() === 12 || args.date.getDate() === 14)) {
            args.element['style'].background = '#deecfc';
        }*/
    }

    onCellClick(): void {
    }

    onNavigating(arg: NavigatingEventArgs): void {
    }

    onEventClick(arg: EventClickArgs): void {
    }

    onPopupOpen(args: PopupOpenEventArgs): void {
        this.deleteTarget = {};
        // datetimepicker 초기화
        $('.daterangepicker.dropdown-menu').remove();
        $('.ui-timepicker-wrapper').remove();
        this.showDatePicker = false;
        this.isTrgtNoInvalid = false;

        // title속성때문에 툴팁이 보여지는 현상때문에 title attribute삭제
        const btns = args.element.querySelectorAll('.e-btn');
        const titleDelete = Array.prototype.slice.call(btns);

        titleDelete.forEach( (el) => {
            el.removeAttribute('title');
        });

        if (args.type === 'QuickInfo') {
            this.ovrdPopupType = args.data['ovrdLayerNo'] !== undefined ? 'DELETE' : 'CREATE';
            this.setOvrdApplyScope(args.data);
            if (args.data['Type'] === 'override') {
                const $header = args.element.querySelectorAll('.e-popup-header')[0];
                const overrideTxt = document.createTextNode(this.translate.instant('MK.01385'));
                args.element.classList.add('override');
                $header.appendChild(overrideTxt);

                this.ovrdStDt = args.data['ovrdLayerNo'] !== undefined ? `${StringUtils.getDateStr(args.data['StartTime'])} ${StringUtils.getTimeStr(args.data['StartTime'])}` : '';
                this.ovrdEdDt = args.data['ovrdLayerNo'] !== undefined ? `${StringUtils.getDateStr(args.data['EndTime'])} ${StringUtils.getTimeStr(args.data['EndTime'])}` : '';
            } else {
                args.element.classList.remove('override');
            }

            // 색을 넣을수 있는 header부분에 들어가있는
            const $elem = args.element.querySelectorAll('.e-popup-header')[0];

            // 사용자 이름과
            const $subject = args.element.querySelectorAll('.e-subject-wrap')[0];

            // 팝업 콘텐츠 안에 집어넣고
            const $content = args.element.querySelectorAll('.e-popup-content')[0];

            // 커스텀 팝업이 아닌 기존 syncfusion팝업이라면
            if ($elem) {
                // 사용자 이름을 팝업 콘텐츠 맨 처음에 집어넣고
                $content.insertBefore($subject, $content.childNodes[0]);

                const isPast = args.data['StartTime'] < new Date() && args.data['EndTime'] < new Date();
                if (this.customPopupUseYn && this.authService.isAuthenticate('obj.schedule.**', '*') && !isPast) {
                    // 그 수정버튼은 create override로 명시한다
                    const buttonTxt_create = document.createTextNode(this.translate.instant('MK.01391'));
                    const buttonTxt_delete = document.createTextNode(this.translate.instant('MK.01392'));

                    // 수정버튼
                    const $button = args.element.querySelectorAll('.e-header-icon-wrapper')[0];
                    // 수정 버튼을 콘텐츠에 삽입한다.
                    $content.appendChild($button);

                    if (args.data['Type'] === 'layer') {
                        // 수정 버튼에 create override 텍스트를 넣어준다.
                        $button.childNodes[0].appendChild(buttonTxt_create);
                    } else {
                        // 임시로 삭제 버튼만 적용
                        $button.childNodes[0].appendChild(buttonTxt_delete);
                        $button.removeChild($button.childNodes[1]);
                        // $button.childNodes[1].appendChild(buttonTxt_delete);
                    }
                // TODO: 수정 화면에서도 오버라이드 삭제 버튼을 열어 주고, 오버라이드 삭제 API를 직접 호출하는 것이 아니라 Preview 로 호출하도록 한 후 적용할 것!!!
                } /*else if (!this.customPopupUseYn && this.authService.isAuthenticate('obj.schedule.**', '*') && !isPast) {
                    if (args.data['Type'] === 'layer') {
                        // 권한이 없는 경우 팝업 수정/삭제 버튼 제거
                        $elem.removeChild($elem.firstChild);
                    } else if (!isPast) {
                        // 그 수정버튼은 create override로 명시한다
                        const buttonTxt_delete = document.createTextNode(this.translate.instant('MK.01392'));

                        // 수정버튼
                        const $button = args.element.querySelectorAll('.e-header-icon-wrapper')[0];
                        // 수정 버튼을 콘텐츠에 삽입한다.
                        $content.appendChild($button);

                        // 임시로 삭제 버튼만 적용
                        $button.childNodes[0].appendChild(buttonTxt_delete);
                        $button.removeChild($button.childNodes[1]);
                    }
                }*/ else {
                    // 권한이 없는 경우 팝업 수정/삭제 버튼 제거
                    $elem.removeChild($elem.firstChild);
                }
            }
        } else if (args.type === 'Editor') {
            // console.log(args);
            this.deleteTarget = args.data;
            this.showDatePicker = true;
            this.schdNo = args.data['schdNo'];
            this.schdLayerNo = args.data['layerNo'];
            this.ovrdLayerNo = args.data['ovrdLayerNo'] !== undefined ? args.data['ovrdLayerNo'] : 0;
            //console.log(this.schdNo, this.schdLayerNo, this.ovrdLayerNo);

            // 팝업 타이틀 숨김
            $('.e-dlg-header').hide();
            // 팝업 footer 숨김
            $('.e-footer-content').hide();

            // 팝업 수동 열기 (혹시 모르니 지우지 마세요)
            // $('.e-dlg-container.e-dlg-center-center.e-schedule-dialog-container').css({'z-index': '1003', 'display': 'none', 'position': 'fixed'});
            // $('.e-dialog.e-schedule-dialog.e-dlg-modal.e-control.e-popup').removeClass('e-popup-close');
            // ﻿$('.e-dialog.e-schedule-dialog.e-dlg-modal.e-control.e-popup').addClass('e-popup-open');
            // $('.e-schedule-dialog-container > .e-dlg-overlay').removeClass('e-fade');

            // 팝업 데이터 초기화
            //console.log(args.data);
            this.initPopup(args.data);
        } else {
            console.log('else...');
        }
    }

    /* Override 생성 start */

    // 팝업 데이터 초기화
    initPopup(_data) {
        this.isTrgtNoInvalid = false;
        // $('div[name=overridePopup]').find('input[name=singleSelectInput]').attr('invalid', false);
        $('[name=singleSelectInput]').val('');
        this.isEmptyUser = false;
        this.invalidCnt = 0;
        this.tmznCd = AppUtils.getUseTimezone().tmznCd;
        this.initDate(_data);

        this.getMember();
        this.getTimeZone();

        this.activeData = [];
        // console.log('팝업 초기화');
    }

    initDate(_data) {
        this.isEndBfSt = false;
        this.isEndBfNow = false;
        this.dateTime.stDate = StringUtils.getDateStr(_data['StartTime']);
        this.dateTime.stTime = StringUtils.getTimeStr(_data['StartTime']);
        this.dateTime.endDate = StringUtils.getDateStr(_data['EndTime']);
        this.dateTime.endTime = StringUtils.getTimeStr(_data['EndTime']);
    }

    timezoneChanged(event) {
        //console.log(event);OvrdAplyTrgtSelectConfig
        this.tmznCd = event;
    }

    getTimeZone() {
        this.dataLoaded.emit(false);
        this.commonServices.getCode('TMZN_CD', 'LANG').then(result => {
            if (result.status === 200) {
                this.TimezoneTypeSelectConfig.option = [];
                result.json().data.forEach((timezone: { dispNm: string, cdId: string }) => {
                    this.TimezoneTypeSelectConfig.option.push({
                        label: timezone.dispNm,
                        value: timezone.cdId
                    });
                });
            }
            this.dataLoaded.emit(true);
        });
    }

    setOvrdApplyScope(targetData) {
        if (this.ovrdPopupType === 'CREATE') {
            this.ovrdAplyScopeCd = 'OVRDSCOPE20';
            this.schd.schdLayerList.forEach((_data, index) => {
                _data.isOvrdAplyTrgtLayer =  _data.schdLayerNo === targetData.layerNo;
                /*this.OvrdAplyTrgtSelectConfig.option.push({
                    label: 'layer ' + targetData.LayerId + '///' + _data.schdLayerNo,G
                    value: _data.schdLayerNo});*/
            });
        } else {
            //ovrdLayerNo

            /*console.log((_.find(this.schd.schdLayerList, { 'schdLayerNo': targetData.layerNo })));
            console.log((_.find(this.schd.schdLayerList, { 'schdLayerNo': targetData.layerNo })).schdOvrdLayerList);
            console.log(_.find((_.find(this.schd.schdLayerList, { 'schdLayerNo': targetData.layerNo })).schdOvrdLayerList, {'schdOvrdLayerNo' : targetData.ovrdLayerNo}));*/
            //console.log(targetData);
            if (targetData.layerNo) {
                this.ovrdDelAll = targetData.ovrdAplyScopeCd === 'OVRDSCOPE10';
                //console.dir(_.find(this.schd.schdLayerList, { 'schdLayerNo': targetData.layerNo }));
                //this.ovrdDelAll = (_.find((_.find(this.schd.schdLayerList, { 'schdLayerNo': targetData.layerNo })).schdOvrdLayerList, {'schdOvrdLayerNo' : targetData.ovrdLayerNo})).ovrdAplyScopeCd === 'OVRDSCOPE10' ? true : false;
            }
        }


    }


    getMember() {
        this.dataLoaded.emit(false);
        const queryString = '?page=1&rows=100000&oidx=userNm';

        this.commonServices.getMember(queryString).then(result => {
            const users = [];
            if (result.status === 200) {
                result.json().data.forEach((user: { userNo: string, userNm: string, emailId: string }) => {
                    users.push({        //new SelectItem(
                        id: user.userNo,
                        name: user.userNm,
                        text: user.userNm + ' (' + StringUtils.maskingEmail(user.emailId) + ')'
                    });
                });
                this.useritems = users;
            }
            this.dataLoaded.emit(true);
        });
    }

    onDateChange(event, type) {
        if (type === 'ST') {
            this.dateTime.stDate = event;
        } else {
            this.dateTime.endDate = event;
        }
    }

    onTimeChange(event, type) {
        if (type === 'ST') {
            this.dateTime.stTime = event;
        } else {
            this.dateTime.endTime = event;
        }
    }

    createOverride() {
        this.dataLoaded.emit(false);
        this.scheduleNo.emit(this.schdNo);

        const aplySchdLayerNoList = [];
        if (this.ovrdAplyScopeCd === 'OVRDSCOPE20') {
            this.schd.schdLayerList.forEach(_layer => {
                if (_layer.isOvrdAplyTrgtLayer) {
                    aplySchdLayerNoList.push(_layer.schdLayerNo);
                }
            });
        }

        const postData = {
            schdLayerNo: this.schdLayerNo,
            schdNo: this.schdNo,
            mappTrgtTypeCd: 'MAPTR110',
            mappTrgtNo: this.userNo,
            tmznCd: this.tmznCd,
            stDt: `${this.dateTime.stDate} ${this.dateTime.stTime}`,
            endDt: `${this.dateTime.endDate} ${this.dateTime.endTime}`,
            ovrdAplyScopeCd: this.ovrdAplyScopeCd,
            aplySchdLayerNoList: aplySchdLayerNoList
        };

        this.scheduleServices.postScheduleOverride(this.schdLayerNo, postData).then(result => {
            if (result.status === 200) {
                this.overrideDataLoading = true;
                this.cancel();
                // 차트 데이터 새로 조회
                // this.getChartData();
                // 상세 화면 재조회
                this.reloaded.emit(true);
            }
            this.overrideDataLoading = true;
            this.dataLoaded.emit(true);
        });
    }

    refreshValue(event) {
        //console.log(event.id);
        if (event.id === undefined) {
            this.isEmptyUser = true;
        } else {
            this.isEmptyUser = false;
        }
        this.userNo = event.id;
    }

    // Override 저장
    save() {
        this.overrideDataLoading = false;
        this.overrideValidCheck();
    }

    overrideValidCheck() {
        this.invalidCnt = 0;

        // 사용자 체크
        this.userValidCheck();

        // 시작 시간, 종료 시간 유효성 체크 필요
        this.dateTimeValidCheck();

        if (this.invalidCnt === 0) {
            this.createOverride();
        } else {
            this.overrideDataLoading = true;
            console.log(this.invalidCnt);
        }
    }

    userValidCheck() {
        if ($('.selected_tag').length === 0 || this.isEmptyUser) {
            // 사용자 input 태그에 빨간 테두리 생성
            // $('div[name=overridePopup]').find('input[name=singleSelectInput]').attr('invalid', true);
            this.isTrgtNoInvalid = true;
            this.invalidCnt++;
        }
    }

    dateTimeValidCheck() {
        this.isEndBfSt = false;
        this.isEndBfNow = false;

        if (StringUtils.isEmpty(this.dateTime.stDate)) {
            this.invalidCnt++;
        }
        if (StringUtils.isEmpty(this.dateTime.stTime)) {
            this.invalidCnt++;
        }
        if (StringUtils.isEmpty(this.dateTime.endDate)) {
            this.invalidCnt++;
        }
        if (StringUtils.isEmpty(this.dateTime.endTime)) {
            this.invalidCnt++;
        }

        const startDate = moment(this.dateTime.stDate + ' ' + this.dateTime.stTime).format('YYYY-MM-DD HH:mm');
        const endDate = moment(this.dateTime.endDate + ' ' + this.dateTime.endTime).format('YYYY-MM-DD HH:mm');
        const currDate = moment().format('YYYY-MM-DD HH:mm');

        // 시작시간이 현재시간보다 이전인 경우 (시작시간을 현재시간으로 업데이트)
        if (moment(startDate, 'YYYY-MM-DD HH:mm').diff(currDate, 'YYYY-MM-DD HH:mm') < 0) {
            this.dateTime.stDate = moment().format('YYYY-MM-DD');
            this.dateTime.stTime = moment().format('HH:mm');
        }
        // 종료시간이 시작시간보다 이전인 경우
        if (moment(endDate, 'YYYY-MM-DD HH:mm').diff(startDate, 'YYYY-MM-DD HH:mm') < 0) {
            this.isEndBfSt = true;
            this.invalidCnt++;
        } else {
            this.isEndBfSt = false;
        }
        // 종료시간이 현재시간보다 이전인 경우
        if (moment(endDate, 'YYYY-MM-DD HH:mm').diff(currDate, 'YYYY-MM-DD HH:mm') < 0) {
            this.isEndBfNow = true;
            this.invalidCnt++;
        } else {
            this.isEndBfNow = false;
        }
    }

    // Override 삭제
    delete() {

        if (this.ovrdLayerNo === 0) {
            return;
        }


        if (this.type === 'preview') {
            this.cancel();
            this.previewOvrdDelete.emit(this.deleteTarget); //this.ovrdLayerNo/
        } else {
            this.dataLoaded.emit(false);
            this.scheduleNo.emit(this.schdNo);

            this.scheduleServices.deleteScheduleOverride(this.schdNo, this.ovrdLayerNo).then(result => {
                if (result.status === 200) {
                    this.cancel();

                    // 상세 화면 재조회
                    this.reloaded.emit(true);
                }
                this.dataLoaded.emit(true);
            });
        }


    }

    // Override 팝업 닫기
    cancel() {
        $('.e-dlg-container.e-dlg-center-center.e-schedule-dialog-container').css({
            'z-index': '1003',
            'display': 'none',
            'position': 'fixed'
        });
        $('.e-dialog.e-schedule-dialog.e-dlg-modal.e-control.e-popup').removeClass('e-popup-open');
        $('.e-dialog.e-schedule-dialog.e-dlg-modal.e-control.e-popup').addClass('e-popup-close');
        $('.e-schedule-dialog-container > .e-dlg-overlay').addClass('e-fade');
    }

    /* Override 생성 end */
}

/* 프리뷰 어댑터 */
class PreviewAdaptor extends UrlAdaptor {
    public beforeSend(args: DataManager, xhr: XMLHttpRequest) {
        xhr.withCredentials = true;
        super.beforeSend(args, xhr);
    }

    processResponse(): Object {
        let alertNowDebug;
        const debugStr = StorageUtils.getItem('alertNow.debug');
        if (debugStr) {
            alertNowDebug = JSON.parse(debugStr);
        } else {
            alertNowDebug = {
                syncfusion : false
            };
        }

        const original: Object[] = super.processResponse.apply(this, arguments);
        //console.log('요청', JSON.parse(arguments[4].data));
        //console.log('리턴', original);

        const requestPayload = JSON.parse(arguments[4].data);       //prewview 요청 request의 payload
        const withChartTf = requestPayload.withChartTf;          //chart data 요청 여부
        const onlyChartTf = requestPayload.onlyChartTf;         //chart데이터만 사용여부
        const aplyStDt = StringUtils.getDate(requestPayload.schdLayer.aplyStDt);         //preview data의 적용 일시(이전의 데이터는 chart data가 나오게 처리해아한다!!!!!) 여기 고쳐야함!!!!!!!!!!!!!!!!!!!!!!todo

        const previewOvrdLayerList = requestPayload.schdLayer.schdOvrdLayerList;

        const schdChartData = [];
        const tmpOvrdData = [];
        let ovrdData = [];
        try {
            if (original !== undefined && original['data']['preview']['schdChartList'] !== undefined) {
                //console.log('processResponse !');

                //console.log(original['data']);
                const schdNo = original['data']['preview']['schdNo'];

                //const mappTrgtInfoPreviewStr = StorageUtils.getItem('alertNow.mappTrgtInfo.preview');
                const mappTrgtInfoPreviewStr = StorageUtils.getItem(`alertNow.mappTrgtInfo.preview.${schdNo}`);
                //const mappTrgtInfoPreview = JSON.parse(mappTrgtInfoPreviewStr);
                const mappTrgtInfoPreview = JSON.parse(mappTrgtInfoPreviewStr);


                let blockCnt = 1;

                if (onlyChartTf === 'F') {
                    //console.log('프리뷰 가져옴!');
                    //console.log(original['data']['preview']['schdChartList']);
                    original['data']['preview']['schdChartList'].forEach((_layers: any, lyIdx) => {                                 //리턴결과중 프리뷰 데이터 순회
                        //console.log(_layers);
                        const layerCnt = lyIdx + 1;
                        const layerNo = _layers['layerNo'];
                        //const layerMappTrgtInfo = _.filter(mappTrgtInfoPreview, {'layerNo': _layers['layerNo']});
                        const layerMappTrgtInfo = _.filter(mappTrgtInfoPreview[layerNo], {'layerNo': _layers['layerNo']});

                        //const temp = _.filter(mappTrgtInfoPreviewTemp._layers['layerNo'], {'layerNo': _layers['layerNo']});
                        //console.log(layerMappTrgtInfo);
                        _layers.onCallList.forEach((_blocks: any) => {
                            const mappTrgt = _.find(layerMappTrgtInfo, {'asgnOrdrIdx': _blocks['asgnOrdrIdx']});
                            //console.log(mappTrgt);
                            _blocks.onCallBlkList.forEach((_block) => {
                                const timelineObject = {
                                    Id: blockCnt,
                                    // Subject: mappTrgt['trgtDispNm'],
                                    Subject: alertNowDebug.syncfusion ? 'P-' + mappTrgt['trgtDispNm'] : mappTrgt['trgtDispNm'], //'P-' + mappTrgt['trgtDispNm'],
                                    trgtNo: mappTrgt['trgtNo'],
                                    StartTime: StringUtils.getDate(_block.stDt),
                                    EndTime: StringUtils.getDate(_block.edDt),
                                    IsAllDay: false,
                                    LayerId: layerCnt,
                                    schdNo: schdNo,
                                    layerNo: _layers.layerNo,
                                    CategoryColor: StringUtils.getColor(mappTrgt['colorIndex']),
                                    Type: 'layer',
                                    trgtStatCd: mappTrgt['trgtStatCd'],
                                    trgtRoleCd: mappTrgt['trgtRoleCd'],
                                    trgtRoleNo: mappTrgt['trgtRoleNo']
                                };

                                schdChartData.push(timelineObject);

                                blockCnt++;
                            });
                        });
                    });

                    //오버라이드 프리뷰 셋팅
                    if (previewOvrdLayerList) {
                        //console.log('프리뷰 오버라이드 세팅');
                        previewOvrdLayerList.forEach((ovrd) => {
                            if (ovrd.actnCd === 'I') {
                                const timelineObject = {
                                    Id: blockCnt,
                                    Subject: ovrd.mappTrgtDispNm, //'P-O-' +
                                    trgtNo: ovrd.mappTrgtNo,
                                    StartTime: StringUtils.getDate(moment(ovrd.stDt).utcOffset(ovrd.tmznOfsVal).format('YYYY-MM-DD HH:mm')),
                                    EndTime: StringUtils.getDate(moment(ovrd.endDt).utcOffset(ovrd.tmznOfsVal).format('YYYY-MM-DD HH:mm')),
                                    IsAllDay: false,
                                    LayerId: 2,
                                    schdNo: schdNo,
                                    schdLayerNo: ovrd.schdLayerNo, // 값이 undefined
                                    ovrdLayerNo: ovrd.schdOvrdLayerNo,
                                    CategoryColor: ColorPicker.C444444,
                                    Type: 'override',
                                    trgtStatCd: 'UAST10',
                                    trgtRoleCd: 'ROLE_ADM',
                                    ovrdAplyScopeCd: ovrd.ovrdAplyScopeCd,
                                    ovrdGrpNo: ovrd.ovrdGrpNo,
                                    aplySchdLayerNoList: ovrd.aplySchdLayerNoList
                                };
                                blockCnt++;
                                schdChartData.push(timelineObject);
                            }
                        });
                    }
                }

                //chart Data를 찾으러 가자!!!!!!!
                if (onlyChartTf === 'T' || withChartTf === 'T') {
                    const mappTrgtInfoStr = StorageUtils.getItem('alertNow.mappTrgtInfo');
                    const mappTrgtInfo = JSON.parse(mappTrgtInfoStr);
                    //console.log('chart Data');
                    original['data']['timeline']['schdChartList'].forEach((_layers: any, lyIdx) => {
                        const layerCnt = lyIdx + 1;
                        const layerMappTrgtInfo = _.filter(mappTrgtInfo, {'layerNo': _layers['layerNo']});

                        const currTimestamp = StringUtils.getDate(_layers.currTimestamp);
                        _layers.onCallList.forEach((_blocks: any) => {
                            _blocks.onCallBlkList.forEach((_block) => {
                                const st = new Date(_block.stDt).getTime();
                                const ed = new Date(_block.edDt).getTime();

                                layerMappTrgtInfo.forEach(mappTrgt => {
                                    const aStDt = new Date(mappTrgt['aplyStDt']).getTime();
                                    const aEdDt = new Date(mappTrgt['aplyEndDt']).getTime();

                                    if (mappTrgt['asgnOrdrIdx'] === _blocks['asgnOrdrIdx'] && aStDt <= st && st <= aEdDt && aStDt <= ed && ed <= aEdDt) {
                                        const timelineObject = {
                                            Id: blockCnt,
                                            Subject: alertNowDebug.syncfusion ? 'C-' + mappTrgt['trgtDispNm'] : mappTrgt['trgtDispNm'], //'C-' + mappTrgt['trgtDispNm'],
                                            trgtNo: mappTrgt['trgtNo'],
                                            StartTime: StringUtils.getDate(_block.stDt),
                                            EndTime: StringUtils.getDate(_block.edDt),
                                            IsAllDay: false,
                                            LayerId: layerCnt,
                                            schdNo: schdNo,
                                            layerNo: _layers.layerNo,
                                            CategoryColor: StringUtils.getColor(mappTrgt['colorIndex']),
                                            Type: 'layer',
                                            trgtStatCd: mappTrgt['trgtStatCd'],
                                            trgtRoleCd: mappTrgt['trgtRoleCd'],
                                            trgtRoleNo: mappTrgt['trgtRoleNo']
                                        };

                                        //console.log('aplyStDt', aplyStDt);
                                        //console.log('currTimestamp', currTimestamp);       //todo

                                        const value = aplyStDt < currTimestamp ? currTimestamp : aplyStDt;

                                        if (onlyChartTf === 'F') {
                                            if (timelineObject.EndTime < value) {
                                                schdChartData.push(timelineObject);
                                            } else if (timelineObject.StartTime < value) {

                                                timelineObject.EndTime = value;
                                                schdChartData.push(timelineObject);
                                            }

                                        } else {
                                            schdChartData.push(timelineObject);
                                        }

                                        blockCnt++;
                                    }
                                });

                            });
                        });
                    });

                    //차트에 의한 오버라이드를 그리자.
                    const currOnCallOvrds = [];
                    if (original['data']['timeline']['schdOvrdLayerList'] !== undefined) {
                        //console.log('timeline 오버라이드');
                        original['data']['timeline']['schdOvrdLayerList'].forEach(oLayer => {
                            const mappTrgt = _.find(mappTrgtInfo, {'trgtNo': oLayer['mappTrgtNo']});

                            tmpOvrdData.push({
                                id: 0,
                                // subject: mappTrgt['trgtDispNm'],
                                subject: mappTrgt['trgtDispNm'],
                                trgtNo: oLayer.mappTrgtNo,
                                stDt: oLayer.stDt.substr(0, 16),
                                edDt: oLayer.endDt.substr(0, 16),
                                layerId: 0,
                                color: ColorPicker.C444444,
                                schdNo: schdNo,
                                layerNo: oLayer.schdLayerNo,
                                ovrdLayerNo: oLayer.schdOvrdLayerNo,
                                Type: 'override',
                                trgtStatCd: mappTrgt['trgtStatCd'],
                                trgtRoleCd: mappTrgt['trgtRoleCd'],
                                trgtRoleNo: mappTrgt['trgtRoleNo']
                            });

                            if (oLayer.currOnCallTf === 'T') {
                                currOnCallOvrds.push(oLayer);
                            }
                        });

                        // 오버라이드 중복 제거
                        ovrdData = _.uniqWith(tmpOvrdData, _.isEqual);
                        ovrdData.forEach(ovrd => {
                            blockCnt++;
                            const timelineObj = _.find(schdChartData, {
                                'schdNo': ovrd['schdNo'],
                                'layerNo': ovrd['layerNo']
                            });

                            const timelineObject = {
                                Id: blockCnt,
                                Subject: alertNowDebug.syncfusion ? `C-O-${ovrd.ovrdLayerNo} : ${ovrd.subject}` : ovrd.subject , //'C-O-' + ovrd.subject,
                                trgtNo: ovrd.trgtNo,
                                StartTime: ovrd.stDt,
                                EndTime: ovrd.edDt,
                                LayerId: 2, ///timelineObj.LayerId;
                                CategoryColor: ColorPicker.C444444,
                                schdNo: ovrd.schdNo,
                                layerNo: ovrd.layerNo,
                                ovrdLayerNo: ovrd.ovrdLayerNo,
                                Type: 'override',
                                trgtStatCd: ovrd.trgtStatCd,
                                trgtRoleCd: ovrd.trgtRoleCd,
                                trgtRoleNo: ovrd.trgtRoleNo
                            };
                            // 오버라이드 데이터를 차트 데이터에 매핑
                            if (_.find(schdChartData, {layerNo: timelineObject.layerNo})) {
                                //수정화면에서 삭제한 경우 처리를 위하여 payload에 없는 경우 추가 하지 않는다;
                                if (_.find(previewOvrdLayerList, {schdOvrdLayerNo: timelineObject.ovrdLayerNo})) {
                                    schdChartData.push(timelineObject);
                                }
                            }
                        });
                        // console.log('schdChartData', schdChartData);
                    }

                }
            }
        } catch (e) {
            console.error(e);
        }

        //console.log(schdChartData);
        return schdChartData;
    }
}

/* 커스텀 어댑터 */
class CustomAdaptor extends WebApiAdaptor {

    public beforeSend(args: DataManager, xhr: XMLHttpRequest, settings: Ajax) {
        xhr.withCredentials = true;
        super.beforeSend(args, xhr, settings);
    }

    processResponse(): Object {

        let alertNowDebug;
        const debugStr = StorageUtils.getItem('alertNow.debug');
        if (debugStr) {
            alertNowDebug = JSON.parse(debugStr);
        } else {
            alertNowDebug = {
                syncfusion : false
            };
        }


        const original: Object[] = super.processResponse.apply(this, arguments);
        //console.dir(original);
        const schdChartData = [];
        const tmpOvrdData = [];
        let ovrdData = [];
        try {
            if (original !== undefined && original['data']['schdChartList'] !== undefined) {
                let layerCount = 0;
                original['data']['schdChartList'].forEach(schdChart => {
                    if (_.includes(schdChart['availTfList'], 'T')) {
                        layerCount++;
                    }
                });
                // console.log('layerCount: ', layerCount);
                StorageUtils.setItem('alertnow.chartLayer.cnt', layerCount !== 0 ? layerCount : 1);
                // StorageUtils.setItem('alertnow.chartLayer.cnt', original['data']['schdChartList'].length);

                const mappTrgtInfoStr = StorageUtils.getItem('alertNow.mappTrgtInfo');
                const mappTrgtInfo = JSON.parse(mappTrgtInfoStr);

                let blockCnt = 1;
                original['data']['schdChartList'].forEach((_layers: any, lyIdx) => {
                    const layerCnt = lyIdx + 1;
                    const schdNo = original['data']['schdNo'];
                    const layerMappTrgtInfo = _.filter(mappTrgtInfo, {'layerNo': _layers['layerNo']});

                    _layers.onCallList.forEach((_blocks: any) => {
                        _blocks.onCallBlkList.forEach((_block) => {
                            const st = new Date(_block.stDt).getTime();
                            const ed = new Date(_block.edDt).getTime();

                            layerMappTrgtInfo.forEach(mappTrgt => {
                                const aStDt = new Date(mappTrgt['aplyStDt']).getTime();
                                const aEdDt = new Date(mappTrgt['aplyEndDt']).getTime();

                                if (mappTrgt['asgnOrdrIdx'] === _blocks['asgnOrdrIdx'] && aStDt <= st && st <= aEdDt && aStDt <= ed && ed <= aEdDt) {
                                    const timelineObject = {
                                        Id: blockCnt,
                                        Subject: alertNowDebug.syncfusion ? 'C-' + mappTrgt['trgtDispNm'] : mappTrgt['trgtDispNm'],
                                        trgtNo: mappTrgt['trgtNo'],
                                        StartTime: StringUtils.getDate(_block.stDt),
                                        EndTime: ed - st < 60000 ? new Date(StringUtils.getDate(_block.stDt).getTime() + 60000) : StringUtils.getDate(_block.edDt),
                                        IsAllDay: false,
                                        LayerId: layerCnt,
                                        schdNo: schdNo,
                                        layerNo: _layers.layerNo,
                                        CategoryColor: StringUtils.getColor(mappTrgt['colorIndex']),
                                        Type: 'layer',
                                        trgtStatCd: mappTrgt['trgtStatCd'],
                                        trgtRoleCd: mappTrgt['trgtRoleCd'],
                                        trgtRoleNo: mappTrgt['trgtRoleNo']
                                    };
                                    schdChartData.push(timelineObject);

                                    blockCnt++;
                                }
                            });

                        });
                    });
                });

                const currOnCallOvrds = [];
                if (original['data']['schdOvrdLayerList'] !== undefined) {
                    original['data']['schdOvrdLayerList'].forEach(oLayer => {
                        const schdNo = original['data']['schdNo'];
                        const mappTrgt = _.find(mappTrgtInfo, {'trgtNo': oLayer['mappTrgtNo']});

                        // const st = new Date(oLayer.stDt).getTime();
                        // const ed = new Date(oLayer.endDt).getTime();
                        // const modEdDt = new Date(new Date(oLayer.stDt.substr(0, 16)).getTime() + 60000);

                        tmpOvrdData.push({
                            id: 0,
                            subject: mappTrgt['trgtDispNm'],
                            trgtNo: oLayer.mappTrgtNo,
                            stDt: oLayer.stDt.substr(0, 16),
                            edDt: oLayer.endDt.substr(0, 16),
                            // edDt: ed - st < 60000 ? modEdDt : oLayer.endDt.substr(0, 16),
                            layerId: 0,
                            color: ColorPicker.C444444,
                            schdNo: schdNo,
                            layerNo: oLayer.schdLayerNo,
                            ovrdLayerNo: oLayer.schdOvrdLayerNo,
                            Type: 'override',
                            trgtStatCd: mappTrgt['trgtStatCd'],
                            trgtRoleCd: mappTrgt['trgtRoleCd'],
                            trgtRoleNo: mappTrgt['trgtRoleNo'],
                            ovrdAplyScopeCd: oLayer.ovrdAplyScopeCd,
                            ovrdGrpNo: oLayer.ovrdGrpNo,
                            aplySchdLayerNoList: oLayer.aplySchdLayerNoList
                        });

                        if (oLayer.currOnCallTf === 'T') {
                            currOnCallOvrds.push(oLayer);
                        }
                    });

                    // 오버라이드 중복 제거
                    ovrdData = _.uniqWith(tmpOvrdData, _.isEqual);

                    ovrdData.forEach(ovrd => {
                        blockCnt++;
                        const timelineObj = _.find(schdChartData, {
                            'schdNo': ovrd['schdNo'],
                            'layerNo': ovrd['layerNo']
                        });

                        const timelineObject = {};
                        timelineObject['Id'] = blockCnt;
                        timelineObject['Subject'] = alertNowDebug.syncfusion ? `C-O-${ovrd.ovrdLayerNo} : ${ovrd.subject}` : ovrd.subject; //ovrd.subject;
                        timelineObject['trgtNo'] = ovrd.trgtNo;
                        timelineObject['StartTime'] = ovrd.stDt;
                        timelineObject['EndTime'] = ovrd.edDt;
                        timelineObject['LayerId'] = timelineObj.LayerId;
                        timelineObject['CategoryColor'] = ColorPicker.C444444;
                        timelineObject['schdNo'] = ovrd.schdNo;
                        timelineObject['layerNo'] = ovrd.layerNo;
                        timelineObject['ovrdLayerNo'] = ovrd.ovrdLayerNo;
                        timelineObject['Type'] = 'override';
                        timelineObject['trgtStatCd'] = ovrd.trgtStatCd;
                        timelineObject['trgtRoleCd'] = ovrd.trgtRoleCd;
                        timelineObject['trgtRoleNo'] = ovrd.trgtRoleNo;
                        timelineObject['ovrdAplyScopeCd'] = ovrd.ovrdAplyScopeCd;
                        timelineObject['ovrdGrpNo'] = ovrd.ovrdGrpNo;
                        timelineObject['aplySchdLayerNoList'] = ovrd.aplySchdLayerNoList;

                        // 오버라이드 데이터를 차트 데이터에 매핑
                        //console.log(timelineObject);
                        //console.log('오버라이드', timelineObject);
                        schdChartData.push(timelineObject);
                    });
                }

                // 현재 스케줄
                // 스케줄 목록에서 현재 데이터 바인딩이 제대로 안 되는 경우 발생하여 로컬스토리지에 스케줄 번호 생성
                let currOnCalls = [];
                if (original['data']['currOnCallList'] !== undefined) {
                    currOnCalls = original['data']['currOnCallList'];
                }
                if (currOnCallOvrds.length > 0) {
                    currOnCallOvrds.forEach(ovrd => {
                        currOnCalls.push(ovrd);
                    });
                }
                StorageUtils.setItem(`alertnow.currOnCalls-${original['data'].schdNo}`, JSON.stringify(currOnCalls));

                // 내 다음 스케줄
                let nextMyOnCalls = [];
                if (original['data']['nextMyOnCallList'] !== undefined) {
                    nextMyOnCalls = original['data']['nextMyOnCallList'];
                }
                //StorageUtils.setItem(`alertnow.nextMyOnCalls`, JSON.stringify(nextMyOnCalls));
                StorageUtils.setItem(`alertnow.nextMyOnCalls-${original['data'].schdNo}`, JSON.stringify(nextMyOnCalls));
            }
        } catch (e) {
            console.error(e);
        }
        return schdChartData;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/syncfusion/scheduler/timeline-view.component.ts